// extracted by mini-css-extract-plugin
export var content = "_r5-1";
export var noScroll = "_r5-3";
export var paper = "_r5-0";
export var scrollable = "_r5-2";